import moment from 'moment';
import { getThumbnailByVideoId } from '../../../../api/vault/assets';
import { IAppState } from '../../../../state/reducers';

export async function getThumbnail(state: IAppState): Promise<string> {
  const {
    clipList,
    selectedClipsPreview: {
      preRoll,
      postRoll,
      thumbnailFrame: {
        clipIndex,
        time,
      },
    },
  } = state;

  function isPostRollFrameSelectedAsThumbnail() {
    return clipIndex === clipList.allClips.length;
  }

  let assetId;

  if (clipIndex === 0 && preRoll) {
    assetId = preRoll.asset._id;
  } else if (isPostRollFrameSelectedAsThumbnail()) {
    assetId = postRoll.asset._id;
  } else {
    assetId = state.clipperMediaContent.assetId;
  }

  const momentTime = moment.utc(time * 1000);
  const response = await getThumbnailByVideoId(assetId, {
    hh: momentTime.format('HH'),
    mm: momentTime.format('mm'),
    ss: momentTime.format('ss'),
    ms: momentTime.format('SSS'),
  });
  return response.data.data.path;
}
